import { render, staticRenderFns } from "./smallPopover.vue?vue&type=template&id=228f29f5&scoped=true"
import script from "./smallPopover.vue?vue&type=script&lang=js"
export * from "./smallPopover.vue?vue&type=script&lang=js"
import style0 from "./smallPopover.vue?vue&type=style&index=0&id=228f29f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f29f5",
  null
  
)

export default component.exports